import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UserInfoCard } from '@simOn/common/user-info-card-models';
import { SimIconComponent } from '@simOn/ui/sim-icon';
import { SimUserInfoComponent } from '@simOn/user/info/ui';

export interface EventAssigneesDialogData {
  assignees: UserInfoCard[];
}

@Component({
  selector: 'sim-event-assignees-dialog',
  imports: [SimUserInfoComponent, SimIconComponent],
  templateUrl: './event-assignees-dialog.component.html',
  styleUrl: './event-assignees-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventAssigneesDialogComponent {
  private readonly _dialogRef = inject<DialogRef<void>>(DialogRef);
  protected readonly data = inject<EventAssigneesDialogData>(DIALOG_DATA);

  protected close(): void {
    this._dialogRef.close();
  }
}
